var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.7 61.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #0d5227;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2.23px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e8f3e7;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.7,41.54c0,11.1-8.99,20.09-20.09,20.09H12.47c-3.08,0-5.58-2.5-5.58-5.58V18.1c0-6.16,5-11.16,11.16-11.16H57.12c3.08,0,5.58,2.5,5.58,5.58,0,0,0,29.02,0,29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.49,44.65H26.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.54,31.05c-1.99-1.55-3.6-3.54-4.72-5.81-1.11-2.27-1.7-4.76-1.71-7.28C1.07,8.88,8.38,1.33,17.45,1.12c3.52-.09,6.97,.94,9.87,2.93,2.9,1.99,5.1,4.84,6.29,8.15,1.19,3.31,1.31,6.91,.33,10.29-.97,3.38-2.98,6.37-5.75,8.54-.61,.47-1.1,1.08-1.45,1.77-.34,.69-.52,1.45-.52,2.23v1.26c0,.44-.18,.87-.49,1.18-.31,.31-.74,.49-1.18,.49H11.16c-.44,0-.87-.18-1.18-.49-.31-.31-.49-.74-.49-1.18v-1.26c0-.77-.18-1.52-.51-2.21-.34-.69-.83-1.29-1.43-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.53,7.82c4.19,.71,7.66,4.19,8.37,8.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.7e886e38a9dec9add7a4ac4e73866a90.svg";
export { ForwardRef as ReactComponent };